/* eslint-ignore */
// @ts-nocheck
import React, { useCallback, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '~/assets/ultragaz-logo-white.svg';
import Stepper from '~/components/layout/Stepper';
import NewPassword from './NewPassword';
import Concluded from './Concluded';
import SendEmail from './SendEmail';
import { Body, Container, Content, SideBanner, Img } from './styles';
import EmailMessage from './EmailMessage';

const EsqueciSenha = (props) => {
  const [step, setStep] = useState(props.step || 1);
  const [useInfo, setUseInfo] = useState({});

  useEffect(() => {}, [useInfo, step]);

  const [steppers] = useState([
    'Seu e-mail',
    'Envio de e-mail',
    'Redefinição de senha',
    'Concluído',
  ]);

  const buildComponente = useCallback(() => {
    return (
      {
        1: (
          <SendEmail
            step={step}
            setStep={setStep}
            useInfo={useInfo}
            setUseInfo={setUseInfo}
          />
        ),
        2: (
          <EmailMessage
            step={step}
            setStep={setStep}
            useInfo={useInfo}
            setUseInfo={setUseInfo}
          />
        ),
        3: (
          <NewPassword
            step={step}
            setStep={setStep}
            useInfo={useInfo}
            setUseInfo={setUseInfo}
          />
        ),
        4: (
          <Concluded
            step={step}
            setStep={setStep}
            useInfo={useInfo}
            setUseInfo={setUseInfo}
          />
        ),
      }[step] || (
        <SendEmail
          step={step}
          setStep={setStep}
          useInfo={useInfo}
          setUseInfo={setUseInfo}
        />
      )
    );
  }, [step, useInfo, setUseInfo, setStep]);

  return (
    <Container>
      <SideBanner>
        <Link to="/">
          <Img src={Logo} alt="Logo da Ultragaz" />
        </Link>
        <Stepper activated={step} steppers={steppers} />
      </SideBanner>
      <Content>
        <Body>{buildComponente()}</Body>
      </Content>
    </Container>
  );
};

export default EsqueciSenha;
